import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Check, ContentCopy } from '@mui/icons-material';

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    // Fallback for non-secure contexts / older browsers
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  }
};

// Small icon button that copies `value` and confirms with a check mark.
// Stops click propagation so it can sit inside clickable rows.
const CopyButton = ({ value, label = 'Copy', size = 16, sx }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  if (!value) return null;

  const handleClick = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (await copyText(String(value))) setCopied(true);
  };

  return (
    <Tooltip title={copied ? 'Copied!' : label} placement="top">
      <IconButton
        size="small"
        onClick={handleClick}
        onMouseDown={(e) => e.stopPropagation()}
        aria-label={label}
        sx={{ p: 0.4, color: copied ? '#10b981' : '#94a3b8', '&:hover': { color: copied ? '#10b981' : '#3b82f6' }, ...sx }}
      >
        {copied ? <Check sx={{ fontSize: size }} /> : <ContentCopy sx={{ fontSize: size }} />}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
